import { CommonModule } from '@angular/common';
import { Component, inject, type OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslocoPipe } from '@jsverse/transloco';

import { type KudosItem, KudosService } from '../../services/kudos.service';

@Component({
  selector: 'app-kudos-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    TranslocoPipe,
  ],
  templateUrl: './kudos-dialog.html',
  styleUrl: './kudos-dialog.scss',
})
export class KudosDialogComponent implements OnInit {
  readonly kudosService = inject(KudosService);
  readonly dialogRef = inject(MatDialogRef<KudosDialogComponent>);

  kudosItems = this.kudosService.kudosItems;
  loading = this.kudosService.loading;
  error = signal(false);

  ngOnInit(): void {
    // If not loaded, refresh. But service already does this in constructor.
    // We can just ensure it's loaded.
    if (!this.kudosItems().length && this.loading() === false) {
      this.kudosService.refreshKudos().subscribe({
        error: () => this.error.set(true),
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  openUrl(url: string): void {
    window.open(url, '_blank');
  }

  handleImageError(item: KudosItem): void {
    item.avatar = undefined;
  }
}
